export const formatCurrency = (v) => {
    // First convert string values with commas to a clean format
    const cleanValue = typeof v === 'string' ? v.replace(/,/g, '') : v;

    // Parse the clean value
    const parsedValue = parseFloat(cleanValue);

    // Check if the parsed result is NaN or falsy
    if(isNaN(parsedValue) || !parsedValue) {
        return '0.00';
    }

    return parsedValue.toLocaleString(undefined, { 
        minimumFractionDigits: 2, 
        maximumFractionDigits: 2 
    });
}